import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import SocialButtons from "./SocialButtons";
import { useTranslation } from "react-i18next";
import { Logo } from "./StyledNav";
import InstanceContext from "./context/InstanceContext";
import { resolveUrl } from "../libs/utils";
const FooterContainer = styled.footer`
  flex-direction: row;
  justify-content: space-between;
  display: flex;
  width: 100%;
  background: var(--footer-bg);
  color: rgba(245, 255, 255, 0.6);

  font-size: 14px;
  display: flex;

  align-items: center;
  padding: 20px 2%;

  @media (max-width: 899px) {
    align-items: center;
    display: block;
    padding: 32px 15px 28px 20px;
  }
`;

const ColumnLeft = styled.div`
  flex: 1;

  &:not(:last-child) {
    margin-right: 20px;
  }

  @media (max-width: 899px) {
    margin-right: 0;
    margin-bottom: 61px;
    &:not(:last-child) {
      margin-right: 0;
    }
  }
`;

const ColumnRight = styled.div`
  flex: 4;
  display: flex;
  justify-content: space-around;

  &:not(:last-child) {
    margin-right: 20px;
  }

  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 15px;
    text-align: left;
    flex-direction: column;
    gap: 40px;
  }
  @media (max-width: 899px) {
    &:not(:last-child) {
      margin-right: 0;
    }
  }
`;

const Column = styled.div`
  flex: 1;
`;

const FooterLink = styled(Link)`
  color: rgba(245, 255, 255, 0.6);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: block;
  text-decoration: none;
  margin: 16px 0px;

  &:hover {
    text-decoration: underline;
  }
`;

const Footer = () => {
  const { t } = useTranslation();
  const { info, languageOverrides, settings } = InstanceContext.useInstance();
  const logoSrc = info?.logo?.url
    ? resolveUrl(info.logo.url)
    : `${process.env.PUBLIC_URL}/logo.png`;

  const lo = (key, fallback) => languageOverrides?.[key] ?? fallback;

  return (
    <FooterContainer className="footer">
      <ColumnLeft>
        <Logo className="" src={logoSrc} alt="Logo"></Logo>
        <p className="footer-logo-title">
          {lo("footer_subtitle", "Il Portale Turistico Ufficiale")}
        </p>
        <div className="social-icons desktop mt-5">
          <SocialButtons />
        </div>
      </ColumnLeft>

      <ColumnRight className="footer-right-wrap">
        {settings?.footerLinks?.map((section, sectionIndex) => (
          <Column key={sectionIndex}>
            <h1>{section.title}</h1>
            {section.links?.map((link, linkIndex) => (
              <FooterLink key={linkIndex} to={link.url}>
                {link.title}
              </FooterLink>
            ))}
          </Column>
        ))}
      </ColumnRight>
      <div className="copy-right-wrap">
        <p className="copy-txt">
          {lo(
            "copyright_text",
            "© 2023 Portale Turistico del Comune di Terni.",
          )}{" "}
          Designed By{" "}
          <a href="https://euromediaitalia.com">
            <u>Euromedia</u>
          </a>{" "}
          All Rights Reserved
        </p>
        <div className="footer-icons">
          {lo("footer_logo_url", null) ? (
            <a href={lo("footer_logo_url", "#")} target="_blank">
              <img
                src={lo(
                  "footer_logo_image",
                  "/images/logo-comune_di_terni.png",
                )}
                title={lo("entity_name", "Logo Comune di Terni")}
                className="terni-logo"
                alt={lo("entity_name", "Logo Comune di Terni")}
              />
            </a>
          ) : (
            <a href="https://www.comune.terni.it/" target="_blank">
              <img
                src="/images/logo-comune_di_terni.png"
                title="Logo Comune di Terni"
                className="terni-logo"
                alt="Logo Comune di Terni"
              />
            </a>
          )}
          <a
            href={lo("iat_url", "https://turismo.comune.terni.it/it/info")}
            target="_blank"
          >
            <img
              src="/images/logo-iat.png"
              title="Logo Iat"
              className="iat-logo"
              alt="Logo Iat"
            />
          </a>
          <a
            href={lo("umbria_url", "https://www.umbriatourism.it/it/homepage")}
            target="_blank"
          >
            <img
              src="/images/logo-umbria-cuore-verde.png"
              title="Logo Umbria Cuore Verde"
              className="umbria-logo"
              alt="Logo Umbria Cuore Verde"
            />
          </a>
        </div>
      </div>
    </FooterContainer>
  );
};

export default Footer;
